module.exports = __webpack_public_path__ + "img/newyear_btn_submit_disabled.23336c4e.png";